import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5923">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5924">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5925">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5926">
            <ArrowLeft className="w-4 h-4" data-id="element-5927" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5928">NOIZA</div>
          <div className="w-20" data-id="element-5929" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5930">
        <div className="mb-12" data-id="element-5931">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5932">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5933" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5934">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5935">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5936">
          <section data-id="element-5937">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5938">
              <span className="text-[#006847]" data-id="element-5939">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5940">
              <p data-id="element-5941">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5942">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5943">
                <li data-id="element-5944">Haber leído íntegramente este documento</li>
                <li data-id="element-5945">Comprender su contenido en su totalidad</li>
                <li data-id="element-5946">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5947">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5948">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5949">
              <span className="text-[#006847]" data-id="element-5950">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5951">
              <p data-id="element-5952">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5953">
                <li data-id="element-5954">Software como servicio (SaaS)</li>
                <li data-id="element-5955">Marketplace digital gastronómico</li>
                <li data-id="element-5956">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5957">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5958">
                <li data-id="element-5959">Mostrar su menú digital</li>
                <li data-id="element-5960">Recibir pedidos de clientes</li>
                <li data-id="element-5961">Gestionar su operación interna</li>
                <li data-id="element-5962">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5963">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5964">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5965">
              <span className="text-[#006847]" data-id="element-5966">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5967">
              <p data-id="element-5968">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5969">
                <li data-id="element-5970">No es proveedor de alimentos</li>
                <li data-id="element-5971">No participa en la preparación de productos</li>
                <li data-id="element-5972">No manipula alimentos en ningún momento</li>
                <li data-id="element-5973">No realiza entregas ni logística</li>
                <li data-id="element-5974">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5975">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5976">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5977">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5978">
              <span className="text-[#006847]" data-id="element-5979">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5980">
              <p data-id="element-5981">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5982">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5983">
                <li data-id="element-5984">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5985">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5986">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5987">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5988">
                <li data-id="element-5989">Precios</li>
                <li data-id="element-5990">Menú</li>
                <li data-id="element-5991">Horarios</li>
                <li data-id="element-5992">Métodos de pago</li>
                <li data-id="element-5993">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5994">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5995">
              <span className="text-[#006847]" data-id="element-5996">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5997">
              <div data-id="element-5998">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5999">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6000">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6001">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6002">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6003">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6004">
                  <li data-id="element-6005">Calidad de los alimentos</li>
                  <li data-id="element-6006">Estado, frescura o preparación</li>
                  <li data-id="element-6007">Ingredientes utilizados</li>
                  <li data-id="element-6008">Contaminación cruzada</li>
                  <li data-id="element-6009">Problemas de higiene o salubridad</li>
                  <li data-id="element-6010">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6011">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6012">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6013">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6014">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6015">
                  <li data-id="element-6016">Retrasos en la entrega</li>
                  <li data-id="element-6017">Pérdida de pedidos</li>
                  <li data-id="element-6018">Entregas incompletas</li>
                  <li data-id="element-6019">Errores en dirección</li>
                  <li data-id="element-6020">Conducta de repartidores</li>
                  <li data-id="element-6021">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6022">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6023">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6024">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6025">
                  <li data-id="element-6026">Recepción de pagos</li>
                  <li data-id="element-6027">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6028">Manejo de efectivo</li>
                  <li data-id="element-6029">Confirmación de pagos</li>
                  <li data-id="element-6030">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6031">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6032">
                  <li data-id="element-6033">Pagos no recibidos</li>
                  <li data-id="element-6034">Comprobantes falsos</li>
                  <li data-id="element-6035">Errores en montos</li>
                  <li data-id="element-6036">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6037">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6038">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6039">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6040">
                  <li data-id="element-6041">Reclamos de clientes</li>
                  <li data-id="element-6042">Reembolsos</li>
                  <li data-id="element-6043">Cancelaciones</li>
                  <li data-id="element-6044">Disputas</li>
                  <li data-id="element-6045">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6046">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6047">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6048">
              <span className="text-[#006847]" data-id="element-6049">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6050">
              <p data-id="element-6051">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6052">
                <li data-id="element-6053">Responsable</li>
                <li data-id="element-6054">Legal</li>
                <li data-id="element-6055">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6056">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6057">
                <li data-id="element-6058">Publicar información falsa</li>
                <li data-id="element-6059">Manipular precios de forma engañosa</li>
                <li data-id="element-6060">Simular disponibilidad inexistente</li>
                <li data-id="element-6061">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6062">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6063">
              <span className="text-[#006847]" data-id="element-6064">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6065">
              <p data-id="element-6066">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6067">
                <li data-id="element-6068">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6069">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6070">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6071">
                <li data-id="element-6072">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6073">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6074">
                    <li data-id="element-6075">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6076">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6077">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6078">
              <span className="text-[#006847]" data-id="element-6079">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6080">
              <p data-id="element-6081">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6082">
                <li data-id="element-6083">Menú digital</li>
                <li data-id="element-6084">Gestión de pedidos</li>
                <li data-id="element-6085">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6086">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6087">
                  <p className="font-medium text-white mb-2" data-id="element-6088">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6089">
                    <li data-id="element-6090">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6091">
                  <p className="font-medium text-white mb-2" data-id="element-6092">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6093">
                    <li data-id="element-6094">Propiedad del software</li>
                    <li data-id="element-6095">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6096">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6097">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6098">
              <span className="text-[#006847]" data-id="element-6099">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6100">
              <p data-id="element-6101">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6102">
                <li data-id="element-6103">Disponibilidad continua</li>
                <li data-id="element-6104">Funcionamiento sin interrupciones</li>
                <li data-id="element-6105">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6106">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6107">
                <li data-id="element-6108">Fallas técnicas</li>
                <li data-id="element-6109">Actualizaciones</li>
                <li data-id="element-6110">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6111">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6112">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6113">
              <span className="text-[#006847]" data-id="element-6114">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6115">
              <p data-id="element-6116">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6117">
                <li data-id="element-6118">No está garantizada permanentemente</li>
                <li data-id="element-6119">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6120">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6121">
                <li data-id="element-6122">Destacar o no restaurantes</li>
                <li data-id="element-6123">Modificar posiciones</li>
                <li data-id="element-6124">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6125">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6126">
              <span className="text-[#006847]" data-id="element-6127">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6128">
              <p data-id="element-6129">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6130">
                <li data-id="element-6131">Cumplir con los pagos acordados</li>
                <li data-id="element-6132">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6133">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6134">
                <li data-id="element-6135">Suspender el servicio</li>
                <li data-id="element-6136">Limitar funcionalidades</li>
                <li data-id="element-6137">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6138">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6139">
              <span className="text-[#006847]" data-id="element-6140">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6141">
              <p data-id="element-6142">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6143">
                <li data-id="element-6144">Incumplimiento de términos</li>
                <li data-id="element-6145">Uso indebido</li>
                <li data-id="element-6146">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6147">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6148">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6149">
              <span className="text-[#006847]" data-id="element-6150">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6151">
              <p data-id="element-6152">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6153">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6154">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6155">
              <span className="text-[#006847]" data-id="element-6156">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6157">
              <p data-id="element-6158">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6159">
                <li data-id="element-6160">Pérdidas económicas</li>
                <li data-id="element-6161">Daños indirectos</li>
                <li data-id="element-6162">Lucro cesante</li>
                <li data-id="element-6163">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6164">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6165">
              <span className="text-[#006847]" data-id="element-6166">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6167">
              <p data-id="element-6168">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6169">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6170">
              <span className="text-[#006847]" data-id="element-6171">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6172">
              <p className="font-medium" data-id="element-6173">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6174">
                <li data-id="element-6175">Ha leído este documento completo</li>
                <li data-id="element-6176">Comprende su alcance</li>
                <li data-id="element-6177">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}